<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="5">
            <el-input size="medium" placeholder="搜索关键字: 角色名称" v-model="roleName" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="searchRole()">搜索</el-button>
          </el-col>
          <el-col :span="13">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="success" @click="openDialog(true, null)"
              v-if="checkButtonPermission('system:manage:role:add')">新增角色</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border fixed style="width: 100%">
          <el-table-column prop="roleName" label="角色名称" min-width="100"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
          <!--          <el-table-column prop="deptName" label="所属部门" min-width="120"/>-->
          <el-table-column prop="createTimeStr" label="创建时间" min-width="100"></el-table-column>
          <el-table-column label="操作" min-width="100" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog(false, scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('system:manage:role:edit')">编辑
              </el-button>
              <el-button @click="deleteMenu(scope.row.roleId)" type="danger" size="mini"
                v-if="checkButtonPermission('system:manage:role:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 25, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="menudialogTitle + '角色'" :visible.sync="dialogVisible" :close-on-click-modal="false"
      :modal="false" @close="resetForm()">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="角色信息" name="first">
          <el-form :model="roleForm" label-width="120px" size="medium" style="padding: 0 10%;">
            <el-form-item label="角色名称" prop="roleName">
              <el-input v-model="roleForm.roleName" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="roleForm.remark" clearable></el-input>
            </el-form-item>

            <!--            <el-form-item label="部门" prop="deptId">-->
            <!--              <el-select-->
            <!--                v-if="addFlag != 'info'"-->
            <!--                placeholder="部门"-->
            <!--                v-model="editDialogDeptSelect"-->
            <!--                clearable-->
            <!--                @change="editDialogDeptChange"-->
            <!--                size="medium"-->
            <!--              >-->
            <!--                <el-option v-for="dept in editDialogDepts"-->
            <!--                           :value="dept.deptId"-->
            <!--                           :key="dept.deptId"-->
            <!--                           :label="dept.deptName"-->
            <!--                ></el-option>-->
            <!--              </el-select>-->
            <!--              <span v-else-if="addFlag == 'info'" v-text="editDialogDeptSelect"></span>-->
            <!--            </el-form-item>-->
            <el-form-item label="渠道" prop="channelId">
              <el-select v-model="selectedChannels" multiple placeholder="请选择渠道">
                <el-option v-for="channel in channels" :key="channel.channelId" :label="channel.channelName"
                  :value="channel.channelId">
                </el-option>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label="角色/权限" prop="menuId">-->
            <!--              <el-checkbox-group-->
            <!--                v-model="editDialogMenuSelect"-->
            <!--                @change="editDialogMenuChange"-->
            <!--              >-->
            <!--                <el-checkbox v-for=" item in menuLists"-->
            <!--                             :value="item.menuId"-->
            <!--                             :key="item.menuId"-->
            <!--                             :label="item.menuId">-->
            <!--                  {{item.name}}-->
            <!--                </el-checkbox>-->
            <!--              </el-checkbox-group>-->
            <!--              <br>-->
            <!--              <span>选择的值为: {{ editDialogMenuSelect }}</span>-->
            <!--            </el-form-item>-->
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="菜单权限" name="second">
          <el-tree :data="menuTreeData" show-checkbox default-expand-all node-key="menuId" ref="tree" highlight-current
            :props="defaultProps">
          </el-tree>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('roleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "menuList",
  data() {
    return {
      roleName: '',
      tableData: [],
      roleForm: {},
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 100000,
      addFlag: true,
      dialogVisible: false,
      dialogOperation: '',
      menudialogTitle: '编辑',
      editDialogDepts: [],
      editDialogDeptSelect: '',
      editDialogDeptSelectVal: '',
      editDialogMenuSelect: [],
      editDialogMenuSelectVal: '',
      menuLists: [],
      activeName: 'first',
      channels: [],
      selectedChannels: [],
      menuTreeData: [],
      defaultProps: {
        children: 'childrenList',
        label: 'name'
      }
    }
  },
  created() {
    this.searchRole();
  },
  mounted() {
  },
  methods: {
    searchRole() {
      let reqParam = {
        roleName: this.roleName,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      this.$http.post('/api/system/sysRole/list', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "0") {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {

      })
    },
    editRole(row) {
      this.$http.post('/api/system/sysRole/update', row, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '信息保存成功，角色用户需重新登录后生效',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.searchRole();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    deleteMenu(roleId) {
      this.$confirm('此操作将永久该角色信息, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/system/sysRole/delete?sysRoleId=' + roleId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "0") {
            this.$message({
              message: '删除角色信息成功',
              type: 'success'
            });
            this.dialogVisible = false;
            this.searchRole();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addRole(reqAddParam) {
      this.$http.post('/api/system/sysRole/save', reqAddParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '新增角色信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.searchRole();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })

    },

    editDialogDeptChange(val) {
      console.log('val', val);
      this.editDialogDeptSelectVal = val;
    },
    editDialogGetDept() {
      this.$http.post('/api/system/dept/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "0") {
          this.editDialogDepts = data.resultList;
        }
      }).catch(e => {

      })
    },
    editDialogMenuChange(val) {
      console.log('val', val);
      this.editDialogMenuSelect = val;
    },
    getAllMenus() {
      this.$http.post('/api/system/sysMenu/queryMenuList', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp.data)
        let data = resp.data;
        this.menuTreeData = data.data;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    getChannels() {
      this.$http.post('/api/channel-service/channel/all').then(resp => {
        console.log(resp.data.resultList)
        let data = resp.data;
        this.channels = data.resultList;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    getRoleInfo(roleId) {
      this.$http.post('/api/system/sysRole/viewInfo?sysRoleId=' + roleId, {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp.data.data)
        let data = resp.data.data;
        for (var r in data.channelIdList) {
          this.selectedChannels.push(data.channelIdList[r])
        }
        this.$refs.tree.setCheckedKeys(data.menuIdList);
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    submitForm(formName) {
      console.log(this.$refs.tree.getCheckedKeys());
      // return false;
      if ('add' == this.dialogOperation) {
        let reqAddParam = {
          roleName: this.roleForm.roleName,
          remark: this.roleForm.remark,
          deptId: this.editDialogDeptSelect,
          channels: this.selectedChannels,
          menus: this.$refs.tree.getCheckedKeys()
        }

        this.addRole(reqAddParam);
      } else if ('edit' == this.dialogOperation) {
        console.log('edit');
        let reqEditParam = {
          roleId: this.roleForm.roleId,
          roleName: this.roleForm.roleName,
          remark: this.roleForm.remark,
          deptId: this.editDialogDeptSelectVal,
          channels: this.selectedChannels,
          menus: this.$refs.tree.getCheckedKeys()
        }

        this.editRole(reqEditParam);
      } else {
        console.log('error submit!!');
        return false;
      }

    },
    openDialog(addFlag, row) {

      // this.editDialogGetDept();
      this.getAllMenus();
      this.getChannels();
      if (addFlag) {
        this.menudialogTitle = '新增';
        this.dialogOperation = 'add';
      } else {
        this.getRoleInfo(row.roleId);
        this.menudialogTitle = '编辑';
        let temp = {};
        Object.assign(temp, row);
        console.log(temp);
        this.roleForm = temp;
        this.dialogOperation = 'edit';

        this.editDialogDeptSelect = temp.deptName;
        this.editDialogDeptSelectVal = temp.deptId;
      }
      this.dialogVisible = true;
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchRole();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchRole();
    },
    resetForm() {
      this.activeName = 'first';
      this.roleForm = {};
      this.editDialogDeptSelect = '';
      this.editDialogDeptSelectVal = '';
      this.selectedChannels = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/system/roleList.vue